import React from 'react';
import './styles.css';
import { global } from '../../../../global';
import { CloseCircle } from 'iconsax-react';

const {
  iconLuggageBlue
} = global.img.icons;

function ModalWishToInclude({
  show,
  close,
  continueBuy,
  chooseUpsell,
}) {
  return (
    <>
      {show &&
        <div className='modalWishToIncludeContainer'>
          <div className='modalWishToIncludeCard'>
            <div onClick={() => close(false)} className='modalWishToIncludeCardClose'>
              <CloseCircle size="30" color="#FFFFFF" />
            </div>
            
          <div className='modalWishToIncludeCenter'>
            <div className='modalWishToIncludeCardHead'>
              <div className='modalWishToIncludeCardHeadIconWrap'>
                <img src={iconLuggageBlue} alt='icon Luggage' className='modalWishToIncludeCardHeadIcon'/>
              </div>
            </div>

            <div className='modalWishToIncludeCardBody'>
              <p className='modalWishToIncludeCardBodyTitle'>¿Deseas incluir equipaje?</p>
              <p className='modalWishToIncludeCardBodysubTitle'>Selecciona la tarifa que más se ajuste a ti</p>
            </div>

            <div className='modalWishToIncludeCardFoot'>
              <div className='modalWishToIncludeCardFootBtn' onClick={chooseUpsell}>
                <p className='modalWishToIncludeCardFootBtnText'>Selecciona tu tarifa</p>
              </div>
              <div className='modalWishToIncludeCardFootBtn' onClick={()=>continueBuy(false)}>
                <p className='modalWishToIncludeCardFootBtnText'>Continuar</p>
              </div>
            </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default ModalWishToInclude;